"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var version = '0.6.0';
exports.version = version;



//////////////////
// WEBPACK FOOTER
// C:/Users/henri/node_modules/@tensorflow/tfjs-core/dist/version.js
// module id = 169
// module chunks = 0